/**
 * Roles from API may use `name` (JSON-tagged) or `Name` (default Go encoding).
 * Contributor role is named "user"; admins can create content without the quiz.
 */
export function hasContributorAccess(roles) {
  if (!Array.isArray(roles)) {
    return false;
  }
  return roles.some((r) => {
    const n = r.name ?? r.Name;
    return n === "user" || n === "admin";
  });
}

/**
 * Users who can access create flows in UI.
 * Includes contributor (user), advanced_contributor, and admin.
 */
export function hasCreateAccess(roles) {
  if (!Array.isArray(roles)) {
    return false;
  }
  return roles.some((r) => {
    const n = r.name ?? r.Name;
    return n === "user" || n === "advanced_contributor" || n === "admin";
  });
}
